import * as React from "react";
export const DownArrowIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg data-name="Capa 1" viewBox="0 0 451.846 257.565" {...props}>
    <path d="M225.922 257.565a31.55 31.55 0 01-22.369-9.263L9.269 54.016A31.643 31.643 0 0154.017 9.265L225.922 181.18 397.828 9.271a31.641 31.641 0 0144.744 44.751L248.291 248.309a31.548 31.548 0 01-22.369 9.256z" />
  </svg>
);
